import React from 'react';
import './ThemeSwitcher.css'
import { useState } from 'react';
import { useEffect } from 'react';

const ThemeBtn = () => {
    const [theme, setTheme] = useState(false)

    const themeSwitch = () => {
        setTheme(!theme)
    }

    useEffect(() => {
        if (theme) {
            document.getElementById("Main").classList.add("Dark")
        } else {
            document.getElementById("Main").classList.remove("Dark")
        }
    }, [theme]);


    return ( 
        <button className='ThemeBtn' onClick={themeSwitch}></button>
     );
}
 
export default ThemeBtn;